import {getAllNoteList, getNoteList, updateNote} from "@model/note";
import {getAllCardList, getCardList, updateCard} from "@model/card";
import {apiProjectList, apiTagDelete, apiTagList, apiTagUpdate} from "@/api/AppApi";
import {isWebApp} from "@/electron_interactive";
import {deleteViews, getViewList, updateViewTagName} from "@model/view";

let mTag:any;
let mGroup:any;

/**
 * id,name
 * @param db
 */
export function initTag(db){
    mTag = db.table('tag');
    mGroup = db.table('group');
}

export function getTagById(szId){
    return mTag.get(szId)
}

export function updateTag(tag:any){
    tag.updateTime = Date.now();
    if (isWebApp()){
        return new Promise((resolve, reject) => {
            apiTagUpdate(tag).then(res=>{
                if (res.code == 0){
                    resolve('ok');
                }else{
                    reject(res.message);
                }
            })
        })
    }
    return mTag.put(tag);
}

export function batchUpdateTags(arrayTags:any){
    return mTag.bulkPut(arrayTags);
}

export function removeTag(id:string){
    if (isWebApp()){
        return new Promise((resolve, reject) => {
            apiTagDelete(id).then(res=>{
                if (res.code == 0){
                    resolve('ok');
                }else{
                    reject(res.message);
                }
            })
        })
    }
    //删除该标签下的所有view
    getTagById(id).then(r=>{
        getViewList(r.name).then(rr=>{
            const arrayIds = [];
            for (let i=0;i<rr.length;i++){
                arrayIds.push(rr[i].id);
            }
            if (arrayIds.length > 0){
                deleteViews(arrayIds)
            }
        })
    })

    return mTag.delete(id);
}

export function getTagList(){
    if (isWebApp()){
        return new Promise((resolve, reject) => {
            apiTagList().then(res=>{
                if (res.code == 0){
                    resolve(res.data);
                }
            })
        })
    }else{
        return mTag.orderBy('updateTime').reverse().toArray();
    }
}

export function getTagCount(){
    return mTag.count();
}

/**
 * 获取收藏的
 */
export async function getTagFavorList(){
    return mTag.where('isFavirated').equals(1).toArray()
}

/**
 * 更新所有标签名称
 * @param szOldTagName
 * @param szNewTagName
 */
export async function updateAllTagNameFromProjectCards(szOldTagName:string,szNewTagName:string){
    if (!szOldTagName)return;
    if (szOldTagName == szNewTagName)return;
    //project
    var arrayDatas:any = await getNoteList();
    arrayDatas = arrayDatas.filter(p=>p.tags?.includes(szOldTagName));
    for (let i=0;i<arrayDatas.length;i++){
        let item = arrayDatas[i];
        let nIndex = item.tags.indexOf(szOldTagName);
        if (nIndex >= 0){
            item.tags.splice(nIndex,1,szNewTagName);
            await updateNote(item)
        }
    }
    //card....
    arrayDatas = await getAllCardList();
    arrayDatas = arrayDatas.filter(p=>p.tags?.includes(szOldTagName));
    for (let i=0;i<arrayDatas.length;i++){
        let item = arrayDatas[i];
        let nIndex = item.tags.indexOf(szOldTagName);
        if (nIndex >= 0){
            item.tags.splice(nIndex,1,szNewTagName);
            await updateCard(item);
        }
    }
    //更新视图中的....
    await updateViewTagName(szOldTagName,szNewTagName);

    return 'ok';
}

export async function getEmptyTagsCount(){
    return 0;
}

/**
 * 批量删除标签
 * @param arrayTags
 */
export function deleteEmptyTags(arrayTags){
    const arrayIds:any = [];
    arrayTags.forEach(p=>{
        arrayIds.push(p.id);
    })
    return mTag.bulkDelete(arrayIds);
}



/***************************group*********************/
export function updateGroup(tag:any){
    tag.updateTime = Date.now();
    if (isWebApp()){
        return new Promise((resolve, reject) => {
            apiTagUpdate(tag).then(res=>{
                if (res.code == 0){
                    resolve('ok');
                }else{
                    reject(res.message);
                }
            })
        })
    }
    delete tag.value;
    return mGroup.put(tag);
}

export function batchUpdateGroup(arrayGroups){
    mGroup.bulkPut(arrayGroups);
}

export function groupByName(szName){
    return new Promise(async (resolve) => {
        const arrayGroups = await mGroup.where('name').equalsIgnoreCase(szName).toArray();
        if (arrayGroups.length > 0){
            resolve(arrayGroups[0]);
        }else{
            resolve(null);
        }
    })
}

/**
 * 取这个组的tag
 * @param nGroupId
 */
export async function tagsByGroupId(nGroupId){
    let arrayTags = [];
    if (nGroupId == -1){
        arrayTags = await mTag.filter(p => !p.groupId || p.groupId == -1).toArray();
    }else{
        arrayTags = await mTag.where('groupId').equals(nGroupId).toArray();
    }

    arrayTags.forEach(p=>{
        delete p.isSelected;
        delete p.isChecked;
    })
    return arrayTags;
}

/**
 * 移除组并且修改下面所有的tag
 * @param id
 */
export function removeGroup(id:string){
    if (isWebApp()){
        return new Promise((resolve, reject) => {
            apiTagDelete(id).then(res=>{
                if (res.code == 0){
                    resolve('ok');
                }else{
                    reject(res.message);
                }
            })
        })
    }
    return new Promise(async (resolve) => {
        mGroup.delete(id);
        //将该group下的所有tag的groupid 改为-1
        const arrayTags = await tagsByGroupId(id);
        arrayTags.forEach(p=>{
            p.groupId = -1;
        })
        mTag.bulkPut(arrayTags);
        resolve('ok');
    })
}

export async function getGroupList(){
    if (isWebApp()){
        return new Promise((resolve, reject) => {
            apiTagList().then(res=>{
                if (res.code == 0){
                    resolve(res.data);
                }
            })
        })
    }else{
        const arrayGroups = await mGroup.orderBy('createTime').toArray();
        if (arrayGroups.length > 0 && arrayGroups[0].sort != undefined){
            arrayGroups.sort((a,b)=>{
                return a.sort - b.sort;
            })
        }
        return arrayGroups;
    }
}